export default {
  'admin.marketplace.title': 'Marktplatz-Kuratierung',
  'admin.marketplace.search': 'Nach Name suchen',
  'admin.marketplace.filters.all': 'Alle',
  'admin.marketplace.filters.featured': 'Empfohlen',
  'admin.marketplace.empty':
    'Keine öffentlichen Abonnements entsprechen Ihren Filtern.',
  'admin.marketplace.column.name': 'Name',
  'admin.marketplace.column.owner': 'Besitzer',
  'admin.marketplace.column.total': 'Gesamtpreis',
  'admin.marketplace.column.features': 'Funktionen',
  'admin.marketplace.column.clones': 'Klone',
  'admin.marketplace.column.public': 'Öffentlich',
  'admin.marketplace.column.featured': 'Empfohlen',
  'admin.marketplace.column.created': 'Erstellt',
  'admin.marketplace.publicYes': 'Öffentlich',
  'admin.marketplace.toggle.success': 'Empfohlen-Markierung aktualisiert',
  'admin.marketplace.toggle.error':
    'Empfohlen-Markierung konnte nicht aktualisiert werden',
  'admin.marketplace.features.title': 'Feature-Marktplatz-Kuratierung',
  'admin.marketplace.features.empty':
    'Keine öffentlichen Features entsprechen Ihren Filtern.',
  'admin.marketplace.features.column.title': 'Titel',
  'admin.marketplace.features.column.price': 'Preis',
};
